import { ErrorHandler } from '@angular/core'
import { IErrorService } from '@microsoft/applicationinsights-angularplugin-js'

export class DefaultAngularErrorHandlerWrapper implements IErrorService {
  defaultErrorHandler = new ErrorHandler()
  handleError(error: unknown) {
    this.defaultErrorHandler.handleError(error)
  }
}
